import React from "react"
import { Route, Routes } from "react-router-dom"
import Home from "./Home/Home"
import { CommunicationDetails } from "./CommunicationDetails/CommunicationDetails"
import LoadedClients from "../Clients/LoadedClients/LoadedClients"
import { ClientDetails } from "../Clients/LoadedClients/ClientDetails/ClientDetails"

export default function EVentanilla() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path=":id/*" element={<CommunicationDetails />} />
      <Route path="loadedClients">
        <Route index element={<LoadedClients />} />
        <Route path="detalleCliente/:cuit" element={<ClientDetails />} />
      </Route>
      <Route path="detalleCliente/:cuit" element={<ClientDetails />}></Route>
    </Routes>
  )
}
